module.exports = __webpack_public_path__ + "img/robot-swiper-img6.ba5c5fa5.png";